<template>
    <v-container fluid id="medical_history_visit">
        <v-row>
            <v-col cols="12">
                <v-card class="mb-4">
                    <v-card-title>Wyszukiwanie</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <v-menu
                                    ref="startDateMenu"
                                    v-model="startDateMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="filters.startDate"
                                            label="Data początkowa"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            clearable
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="filters.startDate"
                                        no-title
                                        scrollable
                                        @input="startDateMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-menu
                                    ref="endDateMenu"
                                    v-model="endDateMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="filters.endDate"
                                            label="Data końcowa"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            clearable
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="filters.endDate"
                                        no-title
                                        scrollable
                                        @input="endDateMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-select
                                    v-model="filters.status"
                                    :items="statusOptions"
                                    label="Status"
                                    clearable
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-right">
                                <v-btn color="primary" @click="applyFilters">Szukaj</v-btn>
                                <v-btn text @click="resetFilters">Wyczyść</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                        :options.sync="pagination"
                        :items="items"
                        :loading="loading"
                        :server-items-length="totalResults"
                        :footer-props="{itemsPerPageOptions:[20,50,100,200]}"
                        :headers="headers">
                    <template v-slot:item="props">
                        <tr :class="{'incomming-visit': incommingVisit(props.item.startTime,props.item.status)}">
                           <td>{{getFormattedDate(props.item.startTime)}}</td>
                            <!--<td>{{getFormattedDate(props.item.endTime)}}</td>-->
                            <td>{{props.item.therapistName}}</td>
                            <td>{{ getStatusDescription(props.item.status, props.item.startTime, props.item.statusSubtype) }}</td>
                            <td>{{props.item.notes}}</td>
                            <!--<td>{{props.item.process}}</td>-->
                            <!--<td>{{props.item.recognition}}</td>-->
                            <td>{{props.item.tworca}}</td>
                            <!--<td>{{props.item.ilosc_zmian_terminu}}</td>-->
                            <td v-if="!hideedit">
                                <v-icon small class="mr-2" @click="editVisit(props.item.id)" v-if="$can('do','POKO_Wizyty_Edycja') && !hideedit" title="Edytuj wizyte">fa-user-edit</v-icon>
                                <v-icon small class="mr-w" v-if="$can('do','POKO_SystemAdmin') || isTherapist" color="primary" @click="showQuickVisitInfo(props.item.id)" title="Informacje o wizycie">fa-eye</v-icon>          
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn v-if="$can('do','POKO_Wizyty_Edycja') && enable_print" color="primary" @click="getDocumentation">Wydruk dokumentacji</v-btn>          
        </v-col>
      </v-row>
        <VisitEditor :visitData="editorData" :visible="showVisitEditor" v-if="showVisitEditor" @close="showVisitEditor = false" :typywizyt="typywizyt" :hidevisithistory="onlyclosed"></VisitEditor>
        <v-dialog v-model="showVisitQuickInfoTherapist" transition="dialog-bottom-transition" max-width="700px">
            <v-card>
                <v-toolbar dark class="primary">
                <v-btn icon @click.native="showVisitQuickInfoTherapist = false" dark>
                    <v-icon>fa-times</v-icon>
                </v-btn>
                <v-toolbar-title>Szczegóły wizyty</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                <VisitQuickInfo v-if="showVisitQuickInfoTherapist" :visit-id="selectedVisitQuickInfoId" :typywizyt="typywizyt" :show-therapist-info="true" />
                </v-card-text>
            </v-card>      
        </v-dialog>        
    </v-container>
</template>

<script>


    import {visitService} from "../../services/visit.service";

    import * as dayjs from "dayjs";
    import {clientService, settingsService, therapistsService} from "@/services";
    import swal from "sweetalert";
    import { mapState } from 'vuex';

    export default {
        name: "MedicalVisitHistory",
        components: {  VisitEditor: () => import('../visits/VisitEditor.vue'), VisitQuickInfo: () => import('../visits/VisitQuickInfo.vue')},
        props: ["clientid","hideprocess","hideedit","onlyclosed"],
        data() {
            return {
                showAddEditUser: false,
                showResetPassword: false,
                totalResults: 0,
                selectedVisitId: 0,
                loading: true,
                items: [],
                pagination: {},
                editorData: null,
                showVisitEditor: false,
                enable_print: false,
                startDateMenu: false,
                endDateMenu: false,
                showVisitQuickInfoTherapist: false,
                selectedVisitQuickInfoId: 0,                
                filters: {
                    startDate: null,
                    endDate: null,
                    status: null
                },
                statusOptions: [
                    { text: 'Planowana/Nowa', value: 0 },
                    { text: 'Potwierdzona', value: 1 },                    
                    { text: 'Zakończona', value: 3 },
                    { text: 'Odwołana przez pracownika', value: 4 },
                    { text: 'Odwołana przez placówkę', value: 5 },
                    { text: 'Nieobecność usprawiedliowiona', value: 6 },
                    { text: 'Nieobecność nieusprawiedliowiona', value: 7 }
                ],
                headers: [
                    {text: 'Początek', sortable: false, align: 'left', value: 'startTime'},
                    //{text: 'Koniec', sortable: false, align: 'left', value: 'endTime'},
                    {text: 'Terapeuta', sortable: false, align: 'left', value: 'therapistName'},
                    {text: 'Status', sortable: false, align: 'left', value: 'status'},
                    {text: 'Uwagi', sortable: false, align: 'left', value: 'notes'},
                    //{text: 'Badania/Zabiegi', sortable: false, align: 'left', value: 'process'},
                    //{text: 'Rozpoznanie', sortable: false, align: 'left', value: 'recognition'},
                    {text: 'Kto zarejestrował?', sortable: false, align: 'left', value: 'tworca'},
                    //{text: 'Ilośc zmian terminu', sortable: false, align: 'left', value: 'ilosc_zmian_terminus'},
                    {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
                ],                
            }
        },
        mounted() {
          this.checkTempaltes()
          this.getAllTypyWizyt()
        },
        computed:{
            ...mapState('account', ['userdetails']),
            isTherapist() {
                return this.userdetails.therapistDetails != null
                //$can('do','POKO_SystemAdmin'
            },
        },
      methods: {
        showQuickVisitInfo(id) {
          this.showVisitQuickInfoTherapist = true
          this.selectedVisitQuickInfoId = id
        },
        showError(text) {
          swal({
            title: "Błąd",
            text: text,
            icon: "warning",
            button: "OK"
          })
        },
        getAllTypyWizyt() {
          therapistsService.GetWszystkieTypyWizyt().then(result => {
            this.typywizyt = result.data.result
          }).catch(() => {
            this.error("Nie można pobrać typów wizyt terapeutów.");
          })
        },
        applyFilters() {
            this.pagination.page = 1; // Reset to first page when applying filters
            this.requestVisits().then(data=> {
                this.items = data.data.result.items,
                    this.totalResults = data.data.result.totalCount
                this.loading = false
            })
        },
        resetFilters() {
            this.filters = {
                startDate: null,
                endDate: null,
                status: null
            };
            this.applyFilters();
        },
        requestVisits() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
            let sortValue = ''
            if(sortBy.length > 0) {
                sortValue = sortBy[0]
                if(sortDesc.length > 0)
                    sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
            }
            
            let filterParams = {
                startDate: this.filters.startDate ? dayjs(this.filters.startDate).format('DD-MM-YYYY') : null,
                endDate: this.filters.endDate ? dayjs(this.filters.endDate).format('DD-MM-YYYY') : null,
                status: this.filters.status,
                statusSubtype: null
            };
            if(this.filters.status >= 4)
            {
                if(this.filters.status == 4)
                    filterParams.statusSubtype = 1
                else if(this.filters.status == 5)
                    filterParams.statusSubtype = 2
                else if(this.filters.status == 6)
                    filterParams.statusSubtype = 3
                else if(this.filters.status == 7)
                    filterParams.statusSubtype = 4
                filterParams.status = 2
            }

            var req = visitService.GetVisitsHistory({ 
                query: '', 
                page: page, 
                limit: itemsPerPage, 
                sorting: sortValue, 
                clientID: this.clientid,
                ...filterParams
            }, this.onlyclosed)

            return req.catch(() => {
                this.showError("Błąd pobierania historii wizyt");
                this.loading = false;
            });
        },
        getFormattedDate(val)
        {
            let dj = dayjs(val)
            if(dj != null)
            {
                return dj.format("DD-MM-YYYY HH:mm")
            }
            else
            {
                return val
            }
        },
        getDocumentation()
        {
            clientService.getMedicalDocumentation(this.clientid).then((result)=> {
              let res = result.data.result
              let a = document.createElement("a"); //Create <a>
              a.href = "data:application/octet-stream;base64," + res.fileBase64; //Image Base64 Goes here
              a.download = res.fileName; //File name Here
              a.setAttribute('target','_blank');
              a.click(); //Downloaded file
            }).catch(() => {
              this.showError('Bład pobierania dokumentacji medycznej')
            })

        },
        incommingVisit(date,status)
        {
            const today = dayjs(new Date())
            const checkDate = dayjs(date)
            return today.isBefore(checkDate) && status < 2
        },
        getStatusDescription(status,date,subtype)
        {
            const today = dayjs(new Date())
            const checkDate = dayjs(date)
            let planowana = today.isBefore(checkDate)
            if(subtype != 0)
            {
                switch(subtype)
                {
                    case 1:
                        return 'Odwołana przez pracownika'
                    case 2:
                        return 'Odwołana przez placówkę'
                    case 3:
                        return 'Nieobecność usprawiedliowiona'
                    case 4:
                        return 'Nieobecność nieusprawiedliowiona'
                }
            }
            switch(status)
            {
                case 0:
                    if(planowana)
                        return 'Planowana'
                    else
                        return 'Nowa'
                case 1:
                    return 'Potwierdzona'
                case 2:
                    return 'Anulowana'
                case 3:
                    return 'Zakończona'
                default:
                    return ''
            }
        },
        editVisit(id)
        {
            this.showVisitEditor = true
            this.editorData = { Id: id }

        },
        checkTempaltes()
        {
          settingsService.getAgreeTemplates().then(result=> {
            let templates = result.data.result

            this.enable_print = templates.find(x=>x.type == 7) != null
          }).catch(() => {
            this.showError('Bład pobierania wgranych zgód')
          })
        }
    },
    watch: {
        pagination: {
            handler() {
                this.requestVisits().then(data=> {
                    this.items = data.data.result.items,
                        this.totalResults = data.data.result.totalCount
                    this.loading = false
                })
            },
            deep: true
        }
    }
}
</script>

<style>
    #medical_history_visit .incomming-visit {
        background-color: #a1efff !important;
    }
</style>